import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// material-ui icons

import Unity, { UnityContent } from "react-unity-webgl";

// core components
import Button from "components/CustomButtons/Button.js";

import styles from 'views/component/Styles.js'

const useStyles = makeStyles(styles);

export default function Template(props) {
    const { testcase, showResult, onTestcaseChange, scenarioId, height, onFullScreen } = props;
    const classes = useStyles();
    const unityInstance = useRef();
    const [unityLoaded, setUnityLoaded] = useState(false);
    const [unityInit, setUnityInit] = useState(false);
    const noFacility = ['트랙', '분류', '워커', 'RGV'];

    useEffect(() => {
        if (unityLoaded && testcase && testcase.testcaseId && unityInstance.current) {
            loadTestcaseUnity(testcase.testcaseId);
            if (showResult) {
                axios.get('data/result/unity/' + testcase.testcaseId).then(response => {
                    if (response.data.resultFacility) {
                        let temp = JSON.parse(JSON.stringify(response.data));
                        let { resultProduct, resultTime, endDate, startDate, testcaseId, ...rest } = temp;
                        rest.resultState.sort((a, b) => a.startTime < b.startTime ? -1 : a.startTime > b.startTime ? 1 : 0)
                        unityInstance.current.unityContent.send("Bridge", "SetLog", JSON.stringify(rest));
                    }
                });
            }
        }
    }, [unityLoaded, testcase]);
    
    const loadTestcaseUnity = function (testcaseId) {
        axios.get('data/testcase/unity/' + testcaseId).then(response => {
            let temp = response.data;
            if (temp.drawing) {
                temp.drawing = axios.defaults.baseURL + '/data/download/drawing/' + scenarioId;
            }
            if (unityInstance.current){
                console.log(unityInstance.current.unityContent, temp)
                unityInstance.current.unityContent.send("Bridge", "SetFacility", JSON.stringify(temp));
            }
        });
    }
    const unityContent = new UnityContent(
        "Build/Unity_KT.json",
        "Build/UnityLoader.js"
    );
    unityContent.on("loaded", () => {
        setUnityLoaded(true);
        // unity focus 문제
        const script = document.createElement('script');
        script.innerHTML = 'var canvas = document.getElementById("#canvas"); canvas.setAttribute("tabIndex", "1"); canvas.focus();';
        document.body.appendChild(script);
    });
    unityContent.on("isFullScreen", (isFull) => {
        if (onFullScreen) {
            onFullScreen(isFull);
        }
    });
    unityContent.on("saveFacility", (data) => {
        const jsonData = JSON.parse(data);
        console.log(jsonData);
        axios.post('data/facility/unityedit', {
            testcaseId : testcase.testcaseId,
            facilityList: jsonData.saveList.map(item => {
                return { ...item, facilityId: isNaN(item.facilityId) ? -1 : item.facilityId, name : item.facilityName };
            }),
            removedFacilityList: jsonData.saveList.filter(item => {
                return !isNaN(item.facilityId) && noFacility.includes(item.modelType)
                    && parseInt(item.positionX) === -1 && parseInt(item.positionY) === -1;
            }), 
        }).then(response => {
            let nameMap = {};
            response.data.facilityList.forEach(item => {
                nameMap[item.name] = item.facilityId;
            });
            let connList = jsonData.connectList.map(item => {
                return { inId: isNaN(item[0]) ? nameMap[item[0]] : item[0], outId: isNaN(item[1]) ? nameMap[item[1]] : item[1] };
            });
            axios.post('data/connection/unityedit', { testcaseId: testcase.testcaseId, connection: connList }).then(response => {
                onTestcaseChange();
            });
        });
    });
    unityContent.on("oninitunity", () => {
        setUnityInit(true);
    });
    useEffect(() => {
        if (unityInit) {
            unityInstance.current.unityContent.send("Bridge", showResult ? 'SetSimMode' : 'SetDesignMode');
        }
    }, [unityInit]);

    return (
        <><div>
            <Button size="sm" color="infoOutline"
                onClick={e => { unityInstance.current.unityContent.setFullscreen(true); }}>전체화면</Button>
        </div>
            <div className={classes.center} style={{ height: height }}>
                <Unity unityContent={unityContent} ref={unityInstance} />
            </div>
        </>
    );
}